import React from 'react'

import { ZariContext } from '_zari/context'
import { Table, Modal, Button } from '_zari/core'

import * as OrdenesCompraService from 'services/ordenCompra.service'

const OrdenesCompraModal = ({ show, handleClose, idSocio, dispatch }) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaOrdenes, setListaOrdenes] = React.useState([])

  React.useEffect(() => {
    OrdenesCompraService.obtenerxIdSocioAsMovimientosPresupuesto(idSocio)
      .then(({ data }) => {
        setListaOrdenes(data)
      })
      .catch(({ data: { error } }) => {
        __zariContext.toast('error', error)
        setListaOrdenes([])
      })
  }, [__zariContext, idSocio])

  const clickSeleccionarOrden = React.useCallback(
    idOrdenCompra => {
      OrdenesCompraService.obtenerDetallesxIdOrdenAsInfoMovimientosPresupuesto(idOrdenCompra)
        .then(({ data }) => {
          if (data) {
            dispatch({ type: 'fill', payload: data })
            handleClose()
          }
        })
        .catch(({ data: { error } }) => {
          __zariContext.toast('error', error)
        })
    },
    [__zariContext, dispatch, handleClose]
  )

  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header>
        <Modal.Title>SELECCIONAR ORDEN</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          containerId='ordenes-lista'
          filas={listaOrdenes}
          headRows={[{ label: 'FECHA' }, { label: 'ESTADO' }, { label: 'IMPORTE' }, { label: 'GLOSA' }, { label: '' }]}
          maxRowsShown={10}
          rowTemplate={row => (
            <Table.Row key={row._id}>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>{row.estado || '--'}</Table.Cell>
              <Table.Cell>{row.importe || '--'}</Table.Cell>
              <Table.Cell>{row.glosa || '--'}</Table.Cell>
              <Table.Cell>
                <Button outline onClick={() => clickSeleccionarOrden(row._id)}>
                  Seleccionar
                </Button>
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(OrdenesCompraModal)
